import { GoToWorkItemDetails, GoToSelectProduct } from '../../state/gsms-route.actions';
import { Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe.decorator';

@Component({
  selector: 'app-work-item-select-type',
  templateUrl: './work-item-select-type.component.html',
  styleUrls: ['./work-item-select-type.component.scss'],
})

@AutoUnsubscribe()
export class WorkItemSelectTypeComponent implements OnInit {
    private workItemID: string;
    private subscription$ = new Subscription();

    constructor(
        private route: ActivatedRoute,
        private store: Store<any>,
    ) { }

    ngOnInit() {
        if (this.route.parent) {
            this.subscription$ = this.route.parent.params.subscribe(params => {
                this.workItemID = params.id;
            });
        }
    }

    goToSelectProductPage() {
        this.store.dispatch(new GoToSelectProduct({ workItemID: this.workItemID }));
    }

    goToDetailsPage() {
        this.store.dispatch(new GoToWorkItemDetails({ workItemID: this.workItemID }));
    }
}
